import { createSelector } from 'reselect';
import { dealsSliceName } from './consts';
export var baseDealsSelector = function (state) { return state[dealsSliceName]; };
export var dealAliasesSelector = createSelector(baseDealsSelector, function (_a) {
    var aliases = _a.aliases;
    return aliases;
});
export var dealsSelector = createSelector(baseDealsSelector, function (_a) {
    var items = _a.items;
    return items;
});
export var dealSelector = function (state, idOrAlias) {
    var _a;
    var deals = dealsSelector(state);
    var aliases = dealAliasesSelector(state);
    var id = (_a = aliases[idOrAlias]) !== null && _a !== void 0 ? _a : idOrAlias;
    return deals[id];
};
